/* eslint prefer-const: off */
import React, {
  useState,
  useEffect
} from 'react';
import { useTranslation}        from 'react-i18next';
import { toast }                from 'react-toastify';
import PropTypes                from 'prop-types';
import DescriptionIcon          from '@material-ui/icons/Description';
import CircularProgress         from '@material-ui/core/CircularProgress';
import InputCheckBox            from '~/components/Input/InputCheckBox';
import Button                   from '~/components/Button';
import Request                  from '~/providers/Request';
import InputControl             from '~/components/Input/InputControl';
import Dialog                   from '~/components/Dialog';
import GridContainer            from '~/components/GridContainer';
import GridItem                 from '~/components/GridItem';
import Text                 from '~/components/Text';
import InputDropzoneFile from '../../../../components/Input/InputDropzoneFile';
import isPresent from '~/utils/isPresent';
import I18n from '~/i18n';

import { appName } from '../../../../config/uri';

function Msg({ error }) {
  return (
    <div>
      <h4>
        {error.length > 1 ? I18n.t('form-toast-errors-title') : I18n.t('form-toast-error-title')}
      </h4>

      {error.map((item, index) => (
        <li key={index}>{item.detail}</li>
      ))}
    </div>
  );
}

const toastfyListErrors = (e) =>{
  toast.error(<Msg error={e}/>, {
    position: 'top-right',
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

const buildMainUsers = (fileData) => {
  return fileData.map(item => {
    const user = {
      name: item.nome_completo,
      cpf: item.cpf ? item.cpf : null,
      cell_phone: item.fone ? item.fone : null,
      email: item.e_mail ? item.e_mail : null,
      external_id: item.id_externo,
      dependents: []
    };
    let relation = null;
    if ( isPresent(item.id_externo_relacionado) ) {
      relation = fileData.find(a => String(a.id_externo) === String(item.id_externo_relacionado) );
    }

    if(relation){ return null; }

    return user;
  }).filter(isPresent);
};

function DialogUploadFile({ corpotarion, handleClose }) {
  const [isLoading, setIsLoading] = useState(true);
  const [driving, setDriving] = useState(false);
  const [doctor, setDoctor] = useState(false);
  const [emergency, setEmergency] = useState(false);
  const [plan, setPlan] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [fileData, setFileData] = useState([]);
  const { t } = useTranslation();

  const trAttr = (attr) => t(`corporation.dialog.${attr}`);

  useEffect(() => {
    // Request.get(`/admin/users/${user.id}/package_billings`, {}, {normalizeJSON: false})
    //   .then( response => {
        setIsLoading(false);
    //     setBillings(response.data);
    //   })
    //   .catch( e => {
    //     console.error(e);
    //     setIsLoading(false);
    //   });

  }, []);

  const handleSendFile = () => {
    setUploadingFile(true);

    const uploadFile = {
      packages: [],
      data: []
    };

    if (driving) {
      uploadFile.packages.push('driving');
    }

    if (doctor) {
      uploadFile.packages.push('doctor');
    }

    if (emergency) {
      uploadFile.packages.push('emergency');
    }

    const mainUsers = buildMainUsers(fileData);

    mainUsers.forEach( (mainUser) => {
      mainUser.dependents = fileData.filter( item =>
        isPresent( item.id_externo_relacionado )
        && item.id_externo_relacionado === mainUser.external_id
      ).map( dependent => ({
        name: dependent.nome_completo,
        cpf: dependent.cpf ? dependent.cpf : null,
        cell_phone: dependent.fone ? dependent.fone : null,
        email: dependent.e_mail ? dependent.e_mail : null,
        external_id: dependent.id_externo,
      }) );
    });

    uploadFile.data = mainUsers;

    Request.post(`/admin/corporations/import_cpf_data/${corpotarion.get('id')}`, uploadFile, {}, {
      normalizeJSON: false,
      disableToastErrors: true
    }).then(() => {
        toast.success('Usuários importados com Sucesso');
        handleClose();
        setUploadingFile(false);
      })
      .catch( e => {
        console.log('Request Error: ', e);
        setUploadingFile(false);
        toastfyListErrors(e.list);
      });
  };

  return (
    <Dialog
      icon={<DescriptionIcon />}
      isOpen
      handleClose={handleClose}
      title={t('corporation.dialog.upload')}
      dialogActions={
        <>
          { fileData.length > 0 && <Text>Total: {fileData.length}</Text> }
          <Button onClick={handleClose} color='red'>
            {t('cancel')}
          </Button>
          {fileData.length > 0 && <Button onClick={handleSendFile} color='green'>
            {uploadingFile ? <CircularProgress color={'primary'} /> : t('send')}
          </Button>}
        </>
      }
    >
      <>
        {fileData.length < 1 &&
          <div style={{minWidth: 750, width: '100%', textAlign: 'center'}}>
            <InputDropzoneFile
              onChange={(value) => setFileData(value) }
            />
          </div>
        }
        {fileData.length > 0 &&
          <>
            <GridContainer>
              { !isPresent(corpotarion.get('disabled_at')) && corpotarion.get('is_doctor') && <GridItem xs={4} sm={4} md={4}>
                <InputControl
                  value={driving}
                  name="doctor"
                  disabled={isLoading}
                  label={'Direção inteligente'}
                  inputComponent={InputCheckBox}
                  onChange={() => setDriving(!driving)}
                />
              </GridItem> }
              { !isPresent(corpotarion.get('disabled_at')) && corpotarion.get('is_driving') && <GridItem xs={4} sm={4} md={4}>
                <InputControl
                  value={doctor}
                  name="driving"
                  disabled={isLoading}
                  label={`${appName} Médico`}
                  inputComponent={InputCheckBox}
                  onChange={() => setDoctor(!doctor)}
                />
              </GridItem> }
              { !isPresent(corpotarion.get('disabled_at')) && corpotarion.get('is_emergency') && <GridItem xs={4} sm={4} md={4}>
                <InputControl
                  value={emergency}
                  name="emergency"
                  disabled={isLoading}
                  label={'Botão de Panico'}
                  inputComponent={InputCheckBox}
                  onChange={() => setEmergency(!emergency)}
                />
              </GridItem> }
              { !isPresent(corpotarion.get('disabled_at')) && corpotarion.get('is_plan') && <GridItem xs={4} sm={4} md={4}>
                <InputControl
                  value={plan}
                  name="plan"
                  disabled={isLoading}
                  label={'Assinatura'}
                  inputComponent={InputCheckBox}
                  onChange={() => setPlan(!plan)}
                />
              </GridItem> }
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <div style={{minWidth: 750, width: '100%', textAlign: 'center'}}>
                  { isLoading && <p>Carregando...</p> }
                  { !isLoading &&
                    <table style={{width: '100%'}}>
                      <thead>
                        <tr>
                          <th>{trAttr('full_name')}</th>
                          <th>{trAttr('cpf')}</th>
                          <th>{trAttr('email')}</th>
                          <th>{trAttr('phone')}</th>
                          <th>{trAttr('external_id')}</th>
                          <th>{trAttr('relation_external_id')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        { fileData.map( (user, index) =>
                          <tr key={index}>
                            <td>{user.nome_completo}</td>
                            <td>{user.cpf}</td>
                            <td>{user.e_mail}</td>
                            <td>{user.fone}</td>
                            <td>{user.id_externo}</td>
                            <td>{user.id_externo_relacionado}</td>
                          </tr>
                        ) }
                      </tbody>
                    </table>
                  }
                </div>
              </GridItem>
            </GridContainer>
          </>
        }
      </>
    </Dialog>
  );
}

DialogUploadFile.propTypes = {
  handleClose: PropTypes.func.isRequired,
  record: PropTypes.any,
};

export default React.memo(DialogUploadFile);
